module.exports = __webpack_public_path__ + "static/media/No-opportunity.d2529ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/No-opportunity.png
// module id = 2613
// module chunks = 17